import { get, post, put, destroy } from 'utils/fetchRequest';

export const getVideos = async (category) => {
    try {
        return await get(`videos${category ? `?category=${category}` : ''}`);
    } catch (err) {
        return { error: err };
    }
};

export const getVideo = async (id) => {
    try {
        return await get(`videos/${id}`);
    } catch (err) {
        return { error: err };
    }
};

export const createVideo = async (data) => {
    try {
        return await post('videos', data);
    } catch (err) {
        return { error: err };
    }
};

export const updateVideo = async (id, data) => {
    try {
        return await put(`videos/${id}`, data);
    } catch (err) {
        return { error: err };
    }
};

export const deleteVideo = async (id) => {
    try {
        return await destroy(`videos/${id}`);
    } catch (err) {
        return { error: err };
    }
};
